import type { PortalNavItem, ResolvedData } from '@/types';
import { AppConstants } from '@/AppConstants';
import { getApiBaseUrl } from '@/hooks';

/**
 * Fetches the landing page module components from the API.
 * API base URL is read at runtime from public/config.json (api.baseUrl).
 */
export async function getPortalNavItems(): Promise<ResolvedData<PortalNavItem>> {
  const base = await getApiBaseUrl();

  const url = `${base}${AppConstants.API_PATHS.GET_PORTAL_NAV_ITEMS}`;

  try {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) {
      return { data: null, error: `API error: ${response.status} ${response.statusText}` };
    }
    const data = (await response.json()) as PortalNavItem;
        
    return { data, error: null };
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Unknown error';
    return { data: null, error: `Failed to fetch module components: ${message}` };
  }
}




